import { useEffect } from 'react';
import thunkActions from '../../store/actions/thunkActions';
import { AppDispatch } from '../../../common/store';
import { useDispatch, useSelector } from 'react-redux';
import carConfigurationSelectors from '../../store/selectors/carConfigurationSelectors';

const useVariantDetailsChange = () => {
  const dispatch: AppDispatch = useDispatch();
  const storeCustomisedCar = useSelector(carConfigurationSelectors.getCustomisedCar);

  useEffect(() => {
    if (storeCustomisedCar?.variantId) {
      dispatch(thunkActions.fetchVariantDetails(storeCustomisedCar.variantId));
    }
  }, [dispatch, storeCustomisedCar?.variantId]);
};

export default useVariantDetailsChange;
